/* eslint-disable import/no-mutable-exports */
import type { Ref } from 'vue'
import type { RouteLocationNormalized, RouteRecordRaw, Router } from 'vue-router'
import { useUserStore } from '@/store/user'

export type ModuleRoute = Record<number | string | symbol, RouteRecordRaw>
export const mixinParams = (moduleMap: ModuleRoute, { moduleName }: { moduleName: string }) => {
  Object.values(moduleMap).forEach(module => (module.meta!.params = { module: moduleName }))
}

let _router: Router
let _route: Ref<RouteLocationNormalized>
export { _route as route, _router as router }
export const registerRouter = (route: Ref<RouteLocationNormalized>, router: Router) => {
  _route = route
  _router = router
}

let schoolSymbol: string
export const getSchoolSymbol = (to?: RouteLocationNormalized) => {
  const route = to || _route.value
  schoolSymbol = route?.params['symbol'] as string
  return schoolSymbol || useUserStore().curSchool?.symbol
}

let centerId: string
export const getCenterId = (to?: RouteLocationNormalized) => {
  if (to?.params['centerId']) {
    centerId = to.params['centerId'] as string
  }
  return centerId
}
